<ng-container [formGroup]="service.formGroup">
  <input [formControlName]="question.getName()" type="number" />
</ng-container>
